<template>
  <b-row
    class="text-left mt-2 survey-results__selected-chart survey-results-filters__filter-variables"
  >
    <b-col cols="12">
      <survey-results-filter-slider
        :max="maxValue"
        :min="minValue"
        :on-update="onUpdate"
        :uid="uid"
        :variable="variable"
        :disabled="disabled"
      />
    </b-col>
  </b-row>
</template>

<script>
import SurveyResultsFilterSlider from '@/components/chart_types/SurveyResultsFilterSlider';
export default {
  name: 'SliderFilter',
  props: ['minValue', 'maxValue', 'disabled', 'variable', 'uid'],
  components: {
    SurveyResultsFilterSlider,
  },
  computed: {
    label: function () {
      return this.variable.short_label
        ? this.variable.short_label
        : this.variable.input_label;
    },
  },
  methods: {
    onUpdate: function (uid, min, max) {
      this.$emit('slider-updated', { uid, min, max });
    },
  },
};
</script>

<style scoped></style>
